<!-- 顶栏右侧部分 -->
<template>
  <el-menu mode="horizontal" :class="['ele-header-right', { 'ele-menu-dark': $store.state.theme.headStyle !== 0 }]">
    <el-menu-item index="full" @click="fullScreen">
      <i :class="isFullScreen ? 'el-icon-_screen-restore' : 'el-icon-_screen-full'"></i>
    </el-menu-item>
    <!--    <el-menu-item index="notice">-->
    <!--      <ele-notice/>&lt;!&ndash; 消息通知组件 &ndash;&gt;-->
    <!--    </el-menu-item>-->
    <!-- <el-menu-item index="feedback" @click="goFeedback">
      <i class="el-icon-_feedback"></i>
      <span>意见反馈</span>
    </el-menu-item> -->
    <el-submenu index="user" popper-class="ele-menu-pop">
      <template slot="title">
        <el-avatar src="https://cube.elemecdn.com/3/7c/3ea6beec64369c2642b92c6726f1epng.png" />
        <span>{{ user.teacherName || '' }}</span>
      </template>
      <!--      <el-menu-item index="info" @click="goUserInfo"><i class="el-icon-user"></i><span>个人中心</span></el-menu-item>-->
      <el-menu-item index="mobile" @click="showMobile"><i class="el-icon-key"></i><span>修改手机</span></el-menu-item>
      <el-menu-item index="password" @click="showPassword"><i class="el-icon-key"></i><span>修改密码</span></el-menu-item>
      <el-divider />
      <el-menu-item index="logout" @click="logout">
        <i class="el-icon-switch-button"></i>
        <span>退出登录</span>
      </el-menu-item>
    </el-submenu>
    <el-menu-item index="more" v-if="$setting.showSetting" @click="showSetting">
      <i class="el-icon-_more"></i>
    </el-menu-item>
  </el-menu>
</template>

<script>
  // import EleNotice from './Notice'

  export default {
    name: 'EleHeaderRight',
    // components: {EleNotice},
    data() {
      return {
        isFullScreen: false, // 是否全屏
      };
    },
    computed: {
      user() {
        // 当前登录用户信息
        return this.$store.state.user.user || {};
      },
    },
    methods: {
      /* 退出登录 */
      logout() {
        this.$confirm('确定要退出登录吗?', '提示', { type: 'warning' })
          .then(() => {
            // 清除缓存的token
            this.$store.dispatch('user/setToken').then(() => {
              // this.$router.push({path: "/login"});
              window.location.replace('/');
            });
          })
          .catch(() => 0);
      },
      /* 跳转到个人中心 */
      // goUserInfo() {
      //   if (this.$route.fullPath !== '/user/info') this.$router.push('/user/info');
      // },
      /* 打开修改密码弹窗 */
      showPassword() {
        this.$store.dispatch('theme/toggle', 'showPassword');
      },
      // 打开修改手机号弹窗
      showMobile() {
        this.$store.dispatch('theme/toggle', 'showMobile');
      },
      // // 跳转到意见反馈
      // goFeedback() {
      //   if (this.$route.fullPath !== '/feedback/index') this.$router.push('/feedback/index');
      // },
      /* 打开主题设置 */
      showSetting() {
        this.$store.dispatch('theme/toggle', 'showSetting');
      },
      /* 全屏 */
      fullScreen() {
        this.isFullScreen = !this.$util.fullScreen();
        if (!this.$setting.watchResize)
          this.$store.dispatch('theme/set', {
            key: 'screenWidth',
            value: document.documentElement.clientWidth || document.body.clientWidth,
          });
      },
    },
  };
</script>
